import * as Yup from "yup";

export const userSchema = Yup.object().shape({
  user_name: Yup.string().required("User name is required"),
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  password: Yup.string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters")
    .matches(/[A-Z]/, "Password must include at least one uppercase letter")
    .matches(/[0-9]/, "Password must include at least one number"),
  user_role: Yup.mixed<"admin" | "editor" | "viewer">()
    .oneOf(["admin", "editor", "viewer"], "Invalid user role")
    .required("User role is required"),
});

export const userEditSchema = Yup.object().shape({
  user_name: Yup.string(),
  email: Yup.string().email("Invalid email address"),
  password: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .matches(/[A-Z]/, "Password must include at least one uppercase letter")
    .matches(/[0-9]/, "Password must include at least one number"),
  user_role: Yup.mixed<"admin" | "editor" | "viewer">().oneOf(
    ["admin", "editor", "viewer"],
    "Invalid user role",
  ),
});

export const authSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email or password")
    .required("Email is required"),
  password: Yup.string()
    .required("Password is required")
    .min(8, "Invalid email or password")
    .matches(/[A-Z]/, "Invalid email or password")
    .matches(/[0-9]/, "Invalid email or password"),
});

export const resetPasswordSchema = Yup.object({
  password: Yup.string().required("Required").min(6),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password")], "Passwords must match")
    .required("Required"),
});

export const variantsSchema = Yup.object({
  url: Yup.string(),
});

export const websiteSchema = Yup.object({
  name: Yup.string().required("Name of the website is required"),
  url: Yup.string().url("Must be a valid URL").required("URL is required"),
  isCustomLogin: Yup.boolean().default(false),
  isSourceSite: Yup.boolean().default(false),
  customLoginPath: Yup.string().url("Must be a valid URL").notRequired(),
  username: Yup.string().notRequired(),
  email: Yup.string().email("Must be a valid email").notRequired(),
  password: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .matches(/[A-Z]/, "Password must include at least one uppercase letter")
    .matches(/[0-9]/, "Password must include at least one number")
    .notRequired(),
});

export const productSchema = Yup.object({
  name: Yup.string().required("Name of the website is required"),
  clientPrice: Yup.number()
    .typeError("Client price must be a number")
    .required("Client price is required"),
  costPrice: Yup.number()
    .typeError("Cost price must be a number")
    .required("Cost price is required"),
  sku: Yup.string().required("SKU is required"),
  ourSiteUrl: Yup.string()
    .url("Must be a valid URL")
    .required("Source url is required"),
  urls: Yup.array()
    .of(Yup.string().url("Must be a valid URL").required("URL is required"))
    .min(1, "At least one URL is required"),
});
